import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import Icon from "./icon.js";

const { redom } = window;
const { el } = redom;

const hash = window.location.hash;

export default class MapLocate {
  constructor() {
    this.el = el(
      ".maplibregl-ctrl .maplibregl-ctrl-group",
      (this.ctrl = el(
        ".maplibregl-ctrl-geolocate",
        (this.icon = new Icon("current-location-filled")),
        {
          onclick: () => {
            if (this.watching) {
              if (this.locked) {
                this.unlocate();
              } else {
                this.locate();
              }
            } else {
              this.locate();
            }
          },
        }
      ))
    );
  }
  onAdd(map) {
    this.map = map;
    if (Capacitor.getPlatform() === "web" && hash) {
      return this.el;
    }
    this.map.once("render", async () => {
      const permissions = await Geolocation.checkPermissions();

      if (
        permissions?.coarseLocation === "granted" ||
        permissions?.location === "granted"
      ) {
        this.el.click();
      }
    });
    return this.el;
  }
  onRemove() {
    this.unlocate();
  }
  updateAccuracyCircleRadius() {
    const { map } = this;
    if (this.accuracyCircleMarker) {
      const bounds = map.getBounds();
      const southEastPoint = bounds.getSouthEast();
      const northEastPoint = bounds.getNorthEast();
      const mapHeightInMeters = southEastPoint.distanceTo(northEastPoint);
      const mapHeightInPixels = map._container.clientHeight;
      const circleDiameter = Math.ceil(
        2 * (this.geolocateAccuracy / (mapHeightInMeters / mapHeightInPixels))
      );
      this.accuracyCircleElement.style.width = `${circleDiameter}px`;
      this.accuracyCircleElement.style.height = `${circleDiameter}px`;
    }
  }
  unlocate() {
    if (this.watching == null) {
      return;
    }
    const { map } = this;
    Geolocation.clearWatch({ id: this.watching });
    this.watching = null;
    this.ctrl.classList.remove("active");
    this.ctrl.classList.remove("loading");
    this.ctrl.classList.remove("locked");
    this.locked = false;
    this.icon.update("current-location");
    if (this.positionMarker) {
      this.positionMarker.remove();
      this.positionMarker = null;
    }
    if (this.accuracyCircleMarker) {
      this.accuracyCircleMarker.remove();
      this.accuracyCircleMarker = null;
    }
    map.off("movestart", this.onMoveStart);
    map.off("zoom", this.onZoom);
    this.onMoveStart = null;
    this.onZoom = null;
  }

  async locate() {
    const { map } = this;

    if (!this.locked) {
      this.locked = true;
      this.ctrl.classList.add("locked");
      this.locked = true;
      this.icon.update("current-location");
      if (this.geolocateLngLat) {
        map.flyTo(
          { center: this.geolocateLngLat, zoom: 15 },
          { geolocateSource: true }
        );
      }

      if (!this.onMoveStart) {
        this.onMoveStart = (e) => {
          if (!e.geolocateSource) {
            map.off("movestart", this.onMoveStart);
            this.onMoveStart = null;
            this.ctrl.classList.remove("locked");
            this.locked = false;
          }
        };
        map.on("movestart", this.onMoveStart);
      }
      if (!this.onZoom) {
        this.onZoom = (e) => {
          this.updateAccuracyCircleRadius();
        };
        map.on("zoom", this.onZoom);
      }
    }
    if (this.watching != null) {
      return;
    }

    const permissions = await Geolocation.checkPermissions();

    if (permissions.coarseLocation === "denied") {
      await Geolocation.requestPermissions(["location", "coarseLocation"]);
    }

    this.ctrl.classList.add("loading");

    let firstLocation = true;

    if (this.positionMarker) {
      const lngLat = this.positionMarker.getLngLat();
      map.flyTo(
        {
          center: lngLat,
          zoom: 15,
        },
        {
          geolocateSource: true,
        }
      );
      firstLocation = false;
    }

    if (this.watching == null) {
      this.accuracyCircleMarker ||
        (this.accuracyCircleMarker = new maplibregl.Marker({
          element: (this.accuracyCircleElement = el(
            ".map-position-accuracy-circle"
          )),
          pitchAlignment: "map",
        }));

      this.watching = await Geolocation.watchPosition(
        {
          enableHighAccuracy: true,
        },
        (position) => {
          if (position == null) {
            this.ctrl.classList.add("error");
            this.icon.update("current-location-off");
            return;
          }
          this.ctrl.classList.remove("error");
          this.icon.update("current-location");
          this.ctrl.classList.add("active");
          this.ctrl.classList.remove("loading");
          const { coords } = position;
          const { accuracy, latitude: lat, longitude: lng } = coords;

          const lngLat = { lng, lat };

          this.geolocateAccuracy = accuracy;
          this.geolocateLngLat = lngLat;

          this.accuracyCircleMarker.setLngLat(lngLat);
          this.accuracyCircleMarker.addTo(map);

          this.updateAccuracyCircleRadius();

          this.positionMarker ||
            (this.positionMarker = new maplibregl.Marker({
              element: el(".map-position-marker"),
              pitchAlignment: "map",
            }));

          this.positionMarker.setLngLat(lngLat).addTo(map);

          if (this.locked) {
            const options = {
              center: lngLat,
              zoom: 15,
            };
            const eventOptions = { geolocateSource: true };
            if (firstLocation) {
              map.flyTo(options, eventOptions);
            } else {
              map.jumpTo(options, eventOptions);
            }
            firstLocation = false;
          }
        }
      );
    }
  }
}
